class HtmlEscapeUtils {
  private escapeEntitiesMap = {
    '&amp;': '&',
    '&gt;': '>',
    '&lt;': '<',
    '&quot;': '"',
    '&#39;': "'",
  };
  private charToEntity = {};
  private entityToChar = {};
  private charToEntityRegex: RegExp;
  private entityToCharRegex: RegExp;

  constructor() {
    this.init();
  }

  /**
   * Convert certain characters (&, <, >, ', and ") to their HTML character equivalents for literal display in web pages.
   * @param {string} value The string to encode.
   * @return {string} The encoded text.
   * @method
   */
  htmlEncode(value: string): string {
    return !value ? value : String(value).replace(this.charToEntityRegex, this.htmlEncodeReplaceFn.bind(this));
  }

  /**
   * Convert certain characters (&, <, >, ', and ") from their HTML character equivalents.
   * @param {string} value The string to decode.
   * @return {string} The decoded text.
   * @method
   */
  htmlDecode(value: string): string {
    return !value ? value : String(value).replace(this.entityToCharRegex, this.htmlDecodeReplaceFn.bind(this));
  }

  /**
   * Checks if a string has values needing to be html encoded.
   * @private
   * @param {String} s The string to test
   * @return {Boolean} `true` if the string contains HTML characters
   */
  hasHtmlCharacters(s: string): Boolean {
    return this.charToEntityRegex.test(s);
  }

  private htmlEncodeReplaceFn(_, capture) {
    return this.charToEntity[capture];
  }

  private htmlDecodeReplaceFn(_, capture) {
    return capture in this.entityToChar
      ? this.entityToChar[capture]
      : String.fromCharCode(parseInt(capture.substr(2), 10));
  }

  private init() {
    const charKeys: string[] = [],
      entityKeys: string[] = [];
    let key: string, escapedChar: string;
    for (key in this.escapeEntitiesMap) {
      if (!this.escapeEntitiesMap.hasOwnProperty(key)) {
        continue;
      }
      escapedChar = this.escapeEntitiesMap[key];
      this.entityToChar[key] = escapedChar;
      this.charToEntity[escapedChar] = key;
      charKeys.push(escapedChar);
      entityKeys.push(key);
    }
    this.charToEntityRegex = new RegExp('(' + charKeys.join('|') + ')', 'g');
    this.entityToCharRegex = new RegExp('(' + entityKeys.join('|') + '|&#[0-9]{1,5};' + ')', 'g');
  }
}

const htmlEscapeUtils = new HtmlEscapeUtils();

export const htmlEncode = s => htmlEscapeUtils.htmlEncode(s);
export const htmlDecode = s => htmlEscapeUtils.htmlDecode(s);
